"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.tab.instructions': 'Instructions',
    'trainer.tab.upload': 'Upload Data',
    'trainer.tab.config': 'Configure Training',
    'trainer.tab.training': 'Training Progress',
    'trainer.tab.results': 'Results',
};
